export const metaColumnsConfig = [
  {
    key: 'riskLevel',
    label: '',
    field: 'metaDetails.riskLevel',
    width: '30px',
    showTouchPadIcon: false, // No icon for risk level column
    showSortIcon: false,
    sortOptions: []
  },
  {
    key: 'name',
    label: 'MOMENT NAME',
    field: 'metaDetails.name',
    width: '270px',
    showTouchPadIcon: true,
    showSortIcon: true,
    sortOptions: [
      { key: 'aToZ', label: 'A to Z', group: 'alphabetical', order: 1 },
      { key: 'zToA', label: 'Z to A', group: 'alphabetical', order: 2 },
      {
        key: 'lowToHigh',
        label: 'Low to High Risk',
        group: 'risk',
        order: 3
      },
      {
        key: 'highToLow',
        label: 'High to Low Risk',
        group: 'risk',
        order: 4
      }
    ]
  },
  {
    key: 'date',
    label: 'DATE',
    field: 'metaDetails.date',
    showTouchPadIcon: true,
    showSortIcon: true,
    sortOptions: [
      {
        key: 'ascending',
        label: 'Sort by Ascending',
        group: 'sort',
        order: 1
      },
      {
        key: 'descending',
        label: 'Sort by Descending',
        group: 'sort',
        order: 2
      },
      { key: 'pinRight', label: 'Pin to Right', group: 'pin', order: 3 },
      { key: 'pinLeft', label: 'Pin to Left', group: 'pin', order: 4 }
    ]
  },
  {
    key: 'productGroup',
    label: 'PG',
    field: 'metaDetails.productGroup',
    showTouchPadIcon: true,
    showSortIcon: false,
    sortOptions: []
  },
  {
    key: 'tier',
    label: 'TIER',
    field: 'metaDetails.tier',
    showTouchPadIcon: true,
    showSortIcon: true,
    sortOptions: [
      {
        key: 'ascending',
        label: 'Sort by Ascending',
        group: 'sort',
        order: 1
      },
      {
        key: 'descending',
        label: 'Sort by Descending',
        group: 'sort',
        order: 2
      },
      { key: 'pinRight', label: 'Pin to Right', group: 'pin', order: 3 },
      { key: 'pinLeft', label: 'Pin to Left', group: 'pin', order: 4 }
    ]
  }
];
